export default __webpack_public_path__ + "static/media/landing-medal.b3ed49b0.jpg";